import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import { StyledTableRow } from "./ui/styled";
import Box from "@mui/material/Box";

const elements = [
  {
    label: "Табельный номер",
    name: "personnelNumber",
  },
  {
    label: "Код ГНИ",
    name: "codeGNI",
  },
  {
    label: "Пенсионное страховое свидетельство",
    name: "pensionInsurance",
  },
  {
    label: "ИНН",
    name: "INN",
  },
  {
    label: "Пол",
    name: "sex",
  },
  {
    label: "Гражданство",
    name: "citizen",
  },
  {
    label: "Особые отметки",
    name: "specialMarks",
  },
  {
    label: "Дата выхода на пенсию",
    name: "retirementDate",
  },
  {
    label: "Особые отметки",
    name: "specialMarksRetirement",
  },
  {
    label: "Дата",
    name: "date",
  },
  {
    label: "Семейное положение",
    name: "familyStatus",
  },
  {
    label: "Резерв на руководящую должность",
    name: "reserveForALeadershipPosition",
  },
  {
    label: "Год зачисления в резерв",
    name: "yearOfEnrollmentInTheReserve",
  },
  {
    label: "№ справки о наличии (отсутствии) судимости",
    name: "certificateOfPresenceAbsenceOfCriminalRecord",
  },
  {
    label: "Дата выдачи",
    name: "dateOfCertificateOfCriminalRecord",
  },
  {
    label: "Дата заполнения личной карточки",
    name: "dateOfFillingOutThePersonalCard",
  },
  {
    label: "Электронная почта",
    name: "email",
  },
  {
    label: "Членство в первичной профсоюзной организации",
    name: "membershipInThePrimaryTradeUnionOrganization",
  },
  {
    label: "№ водительского удостоверения",
    name: "driversLicense",
  },
  {
    label: "Дата выдачи",
    name: "driversLicenseDate",
  },
  {
    label: "Действителен по",
    name: "driversLicenseIsValidUntil",
  },
  {
    label: "Трудовая ведется электронно",
    name: "laborIsConductedElectronically",
  },
  {
    label: "Подано заявление о продолжении ведения трудовой книжки",
    name: "continueMaintainingTheWorkRecordBook",
  },
  {
    label: "Дата отмены",
    name: "cancellationDateMaintainingTheWorkRecordBook",
  },
  {
    label: "Подано заявление о предоставлении сведений о трудовой деятельности",
    name: "anApplicationForProvisionOfInformationAboutLaborActivityHasBeenSubmitted",
  },
  {
    label: "Дата отмены",
    name: "cancellationDateOfInformationAboutLaborActivity",
  },
  {
    label: "Мед. отвод",
    name: "medicalExemption",
  },
];

const GeneralData: FC = () => {
  const handleTextFieldChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    console.log("name", event.target.name);
    console.log("value", event.target.value);
  };

  return (
    <Box marginTop={1} display='flex' flexDirection='column' gap={1}>
      <Box display='flex' gap={1}>
        <TextField
          label="Табельный номер"
          variant="filled"
          size="small"
          name="personnelNumber"
          onChange={(event) => handleTextFieldChange(event)}
        />
         <TextField
          label="Код ГНИ"
          variant="filled"
          size="small"
          name="codeGNI"
          onChange={(event) => handleTextFieldChange(event)}
        />
        <TextField
          label="Пенсионное страховое свидетельство"
          variant="filled"
          size="small"
          name="pensionInsurance"
          onChange={(event) => handleTextFieldChange(event)}
        />
        <TextField
          label="ИНН"
          variant="filled"
          size="small"
          name="INN"
          onChange={(event) => handleTextFieldChange(event)}
        />
        <TextField
          label="Пол"
          variant="filled"
          size="small"
          name="sex"
          onChange={(event) => handleTextFieldChange(event)}
        />
      </Box>
      <Box display='flex' gap={1}>
        <TextField
          label="Гражданство"
          variant="filled"
          size="small"
          name="citizen"
          onChange={(event) => handleTextFieldChange(event)}
        />
         <TextField
          label="Особые отметки"
          variant="filled"
          size="small"
          name="specialMarks"
          onChange={(event) => handleTextFieldChange(event)}
        />
        <TextField
          label="Дата выхода на пенсию"
          variant="filled"
          size="small"
          name="retirementDate"
          onChange={(event) => handleTextFieldChange(event)}
        />
        <TextField
          label="ИНН"
          variant="filled"
          size="small"
          name="INN"
          onChange={(event) => handleTextFieldChange(event)}
        />
        <TextField
          label="Пол"
          variant="filled"
          size="small"
          name="sex"
          onChange={(event) => handleTextFieldChange(event)}
        />
      </Box>
    </Box>
  );
};

export default GeneralData;

//  <TableContainer component={Paper}>
//        <Table size="small">
//         <TableBody>
//           {elements.map(({ name, label }) => (
//             <StyledTableRow key={name}>
//               <TableCell component="th" scope="row" width={300}>
//                 {label}
//               </TableCell>
//               <TableCell>
//                 <TextField
//                   variant="standard"
//                   size="small"
//                   fullWidth
//                   name={name}
//                   onChange={(event) => handleTextFieldChange(event)}
//                 />
//               </TableCell>
//             </StyledTableRow>
//           ))}
//         </TableBody>
//       </Table>  </TableContainer>
